export default __webpack_public_path__ + "fefa41aacf4b7223d230417360419fce.jpg";